<template>
  <div class="flex justify-center">
    <plant-issues
      v-for="issueGroup in issueGroups"
      :key="issueGroup.key"
      :type="issueGroup.type"
      :severity="issueGroup.severity"
      :show-tooltip="true"
      :snoozed-until="issueGroup.snoozed"
      :total-count="issueGroup.totalCount"
      class="mr-2"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { MeterIssueJson } from '@/data/meters/MeterIssueJson.ts';
import PlantIssues from '@/presentation/components/status/icon/PlantIssues.vue';
import _ from 'lodash';

export default {
  name: 'IssuesCell',
  components: { PlantIssues },
  props: {
    issues: { type: Array as PropType<MeterIssueJson[]>, required: true },
  },
  computed: {
    issueGroups() {
      let groupedByType = _.groupBy(this.issues, 'type_name');

      return Object.keys(groupedByType).map((type) => {
        const issues = groupedByType[type];
        const count = issues.length;
        const earliestSnoozedUntil = _.sortBy(issues, 'snoozed_until').find(
          (issue) => issue.snoozed_until !== null,
        );

        return {
          key: issues[0].id + type,
          type: type,
          severity: 'NOK',
          snoozed: earliestSnoozedUntil
            ? earliestSnoozedUntil.snoozed_until
            : null,
          totalCount: count > 1 ? count : null,
        };
      });
    },
  },
};
</script>

<style scoped></style>
